const Rous = (() => {
  const root = window.Shopify?.routes?.root || '/';
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format((cents || 0)/100);
  const galleryThumbs = gallery => qsa('[data-gallery-thumb]',gallery);
  const gallerySlides = gallery => qsa('[data-gallery-slide]',gallery);
  const activeGalleryIndex = gallery => {
    const thumbs=galleryThumbs(gallery);
    const idx=thumbs.findIndex(x=>x.classList.contains('is-active'));
    return idx>=0?idx:0;
  };
  function syncGalleryState(gallery,index){
    const thumbs=galleryThumbs(gallery);
    const slides=gallerySlides(gallery);
    if(!thumbs.length||!slides.length)return;
    const safeIndex=Math.max(0,Math.min(index,Math.min(thumbs.length,slides.length)-1));
    thumbs.forEach((thumb,i)=>{
      const active=i===safeIndex;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-pressed',active?'true':'false');
      if(active) thumb.scrollIntoView?.({block:'nearest',inline:'nearest'});
    });
    slides.forEach((slide,i)=>{
      const active=i===safeIndex;
      const image=qs('.gallery-main-image',slide);
      if(image){image.style.transform='';image.style.transformOrigin='50% 50%';}
      slide.hidden=!active;
      slide.classList.toggle('is-active',active);
    });
    qs('[data-gallery-zoom-area]',gallery)?.classList.remove('rous-inner-zoom-active');
    const counter=qs('[data-gallery-counter]',gallery);
    if(counter)counter.textContent=`${safeIndex+1} / ${thumbs.length}`;
  }
  function activateGalleryThumb(gallery,target){
    if(!gallery||!target)return;
    const thumbs=galleryThumbs(gallery);
    const index=thumbs.indexOf(target);
    if(index<0)return;
    syncGalleryState(gallery,index);
  }
  function stepGallery(gallery,direction){
    const thumbs=galleryThumbs(gallery);
    if(!thumbs.length)return;
    const next=(activeGalleryIndex(gallery)+direction+thumbs.length)%thumbs.length;
    syncGalleryState(gallery,next);
  }

  const rewardsConfig = (() => {
    const el = qs('[data-cart-rewards-config]');
    if (!el) return {freeShipping:49.99, discount10:99.99, discount10Percent:10, discount10Code:'', discount15:149.99, discount15Percent:15, discount15Code:'', discount20:199.99, discount20Percent:20, discount20Code:'', autoApplyDiscountCodes:false, deliveryMinDays:1, deliveryMaxDays:2};
    try { return JSON.parse(el.textContent); } catch(e) { return {freeShipping:49.99, discount10:99.99, discount10Percent:10, discount10Code:'', discount15:149.99, discount15Percent:15, discount15Code:'', discount20:199.99, discount20Percent:20, discount20Code:'', autoApplyDiscountCodes:false, deliveryMinDays:1, deliveryMaxDays:2}; }
  })();
  const euro = value => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(value || 0);

  function addBusinessDays(start, count){
    const d = new Date(start); let added = 0;
    while(added < count){ d.setDate(d.getDate()+1); const day=d.getDay(); if(day!==0 && day!==6) added++; }
    return d;
  }
  function formatDeliveryDate(d){ return new Intl.DateTimeFormat(document.documentElement.lang || 'es-ES', {day:'numeric', month:'short'}).format(d); }
  function renderDeliveryEstimate(){
    const el=qs('[data-delivery-estimate]'); if(!el)return;
    const min=Math.max(1, Number(rewardsConfig.deliveryMinDays)||1), max=Math.max(min, Number(rewardsConfig.deliveryMaxDays)||min);
    const a=addBusinessDays(new Date(), min), b=addBusinessDays(new Date(), max);
    el.textContent = `📦 Entrega estimada: ${formatDeliveryDate(a)}${max>min ? ` – ${formatDeliveryDate(b)}` : ''}`;
  }
  function addDeliveryDays(start, count, skipWeekends){
    if(skipWeekends) return addBusinessDays(start, Math.max(0,count));
    const d=new Date(start);d.setDate(d.getDate()+Math.max(0,count));return d;
  }
  function nextBusinessDate(start){
    const d=new Date(start);
    while(d.getDay()===0||d.getDay()===6)d.setDate(d.getDate()+1);
    return d;
  }
  function formatDeliveryLong(d){
    return new Intl.DateTimeFormat(document.documentElement.lang || 'es-ES',{weekday:'short',day:'numeric',month:'short'}).format(d);
  }
  function renderProductDeliveryTimeline(){
    const el=qs('[data-product-delivery-timeline]');if(!el)return;
    const preparation=Math.max(0,Number(el.dataset.preparationDays)||0);
    const transitMin=Math.max(1,Number(el.dataset.transitMinDays)||1);
    const transitMax=Math.max(transitMin,Number(el.dataset.transitMaxDays)||transitMin);
    const cutoff=Math.min(23,Math.max(0,Number(el.dataset.cutoffHour)||0));
    const skipWeekends=el.dataset.skipWeekends!=='false';
    const now=new Date();
    const orderDate=new Date(now);
    let processingStart=new Date(now);
    const todayIsBusiness=now.getDay()!==0&&now.getDay()!==6;
    if(skipWeekends&&!todayIsBusiness)processingStart=nextBusinessDate(processingStart);
    else if(now.getHours()>=cutoff){processingStart=addDeliveryDays(processingStart,1,skipWeekends);if(skipWeekends)processingStart=nextBusinessDate(processingStart)}
    const prepared=addDeliveryDays(processingStart,preparation,skipWeekends);
    const shipped=new Date(prepared);
    const arrivalMin=addDeliveryDays(shipped,transitMin,skipWeekends);
    const arrivalMax=addDeliveryDays(shipped,transitMax,skipWeekends);
    const orderNode=qs('[data-order-date]',el),preparedNode=qs('[data-prepared-date]',el),shippedNode=qs('[data-shipped-date]',el),arrivalNode=qs('[data-arrival-date]',el),summaryNode=qs('[data-delivery-summary]',el);
    if(orderNode)orderNode.textContent=formatDeliveryLong(orderDate);
    if(preparedNode)preparedNode.textContent=formatDeliveryLong(prepared);
    if(shippedNode)shippedNode.textContent=formatDeliveryLong(shipped);
    if(arrivalNode)arrivalNode.textContent=transitMax>transitMin?`${formatDeliveryLong(arrivalMin)} – ${formatDeliveryLong(arrivalMax)}`:formatDeliveryLong(arrivalMin);
    if(summaryNode)summaryNode.textContent=transitMax>transitMin?`Entrega estimada ${formatDeliveryDate(arrivalMin)} – ${formatDeliveryDate(arrivalMax)}`:`Entrega estimada ${formatDeliveryDate(arrivalMin)}`;
  }
  const rewardTiers = () => [
    {key:'discount10', threshold:Number(rewardsConfig.discount10)||99.99, percent:Number(rewardsConfig.discount10Percent)||10, code:String(rewardsConfig.discount10Code||'').trim()},
    {key:'discount15', threshold:Number(rewardsConfig.discount15)||149.99, percent:Number(rewardsConfig.discount15Percent)||15, code:String(rewardsConfig.discount15Code||'').trim()},
    {key:'discount20', threshold:Number(rewardsConfig.discount20)||199.99, percent:Number(rewardsConfig.discount20Percent)||20, code:String(rewardsConfig.discount20Code||'').trim()}
  ].sort((a,b)=>a.threshold-b.threshold);
  const cartThresholdSubtotal = cart => Number(cart.original_total_price ?? cart.items_subtotal_price ?? cart.total_price ?? 0)/100;
  const unlockedTier = cart => {
    const subtotal=cartThresholdSubtotal(cart);
    return rewardTiers().filter(t=>subtotal>=t.threshold).pop() || null;
  };
  let lastManagedDiscountCode = null;
  async function syncTierDiscount(cart){
    if(rewardsConfig.autoApplyDiscountCodes === false) return cart;
    const tiers=rewardTiers();
    const hasManagedCodes=tiers.some(t=>t.code);
    if(!hasManagedCodes) return cart;
    const subtotal=cartThresholdSubtotal(cart);
    const qualifying=[...tiers].reverse().find(t=>subtotal>=t.threshold && t.code);
    const desiredCode=qualifying?.code || '';
    if(lastManagedDiscountCode === desiredCode) return cart;
    const r=await fetch(`${root}cart/update.js`,{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin',
      body:JSON.stringify({discount:desiredCode})
    });
    let data={};
    try{data=await r.json();}catch(e){}
    if(!r.ok) throw new Error(data?.description || data?.message || 'No se pudo aplicar el descuento.');
    lastManagedDiscountCode=desiredCode;
    return data;
  }
  function renderSavings(cart){
    const savings=Math.max(0,Number(cart.total_discount)||0);
    const tier=unlockedTier(cart);
    const subtotal=cartThresholdSubtotal(cart);
    const freeShippingThreshold=Number(rewardsConfig.freeShipping)||49.99;
    const hasFreeShipping=subtotal>=freeShippingThreshold && cart.item_count>0;
    qsa('[data-cart-savings-row]').forEach(row=>row.hidden=savings<=0);
    qsa('[data-cart-savings]').forEach(el=>el.textContent=money(savings));
    qsa('[data-cart-discount-status]').forEach(el=>{
      el.hidden=savings<=0;
      if(savings>0) el.textContent=tier ? `${tier.percent}% de descuento aplicado automáticamente` : 'Descuento aplicado automáticamente';
    });
    qsa('[data-full-cart-subtotal]').forEach(el=>el.textContent=money(cart.original_total_price ?? cart.items_subtotal_price ?? 0));
    qsa('[data-full-cart-discount-row]').forEach(row=>row.hidden=savings<=0);
    qsa('[data-full-cart-discount]').forEach(el=>el.textContent=savings>0?`−${money(savings)}`:'');
    qsa('[data-full-cart-total]').forEach(el=>el.textContent=money(cart.total_price));
    qsa('[data-full-cart-savings]').forEach(el=>{el.hidden=savings<=0;if(savings>0)el.innerHTML=`🎉 <strong>Ahorras ${money(savings)}</strong> en este pedido`;});
    qsa('[data-cart-free-shipping]').forEach(el=>el.hidden=!hasFreeShipping);
    qsa('[data-full-cart-free-shipping]').forEach(el=>el.hidden=!hasFreeShipping);
    qsa('[data-full-cart-tier]').forEach(el=>{el.hidden=!tier;if(tier)el.textContent=`Nivel activo: ${tier.percent}% de descuento`;});
  }

  function renderRewards(cart){
    const wrap=qs('[data-cart-rewards]'), msg=qs('[data-reward-message]'), bar=qs('[data-reward-progress]'); if(!wrap||!msg||!bar)return;
    const subtotal=cartThresholdSubtotal(cart);
    const fs=Number(rewardsConfig.freeShipping)||49.99;
    const tiers=rewardTiers();
    const t1=tiers[0],t2=tiers[1],t3=tiers[2];
    const max=Math.max(t3?.threshold||1,1); bar.style.width=`${Math.min(100,(subtotal/max)*100)}%`;
    const steps={shipping:subtotal>=fs,discount10:subtotal>=t1.threshold,discount15:subtotal>=t2.threshold,discount20:subtotal>=t3.threshold};
    Object.entries(steps).forEach(([key,on])=>qs(`[data-reward-step="${key}"]`)?.classList.toggle('is-unlocked',on));
    if(cart.item_count===0){ msg.textContent=`Añade productos: desde ${euro(fs)} tienes envío gratis.`; return; }
    if(subtotal<fs) msg.innerHTML=`Te faltan <strong>${euro(fs-subtotal)}</strong> para obtener <strong>envío gratis</strong>.`;
    else if(subtotal<t1.threshold) msg.innerHTML=`🎉 Ya tienes <strong>envío gratis</strong>. Te faltan <strong>${euro(t1.threshold-subtotal)}</strong> para obtener <strong>${t1.percent}% de descuento</strong>.`;
    else if(subtotal<t2.threshold) msg.innerHTML=`🎉 Has desbloqueado <strong>${t1.percent}% de descuento</strong>. Te faltan <strong>${euro(t2.threshold-subtotal)}</strong> para llegar al <strong>${t2.percent}%</strong>.`;
    else if(subtotal<t3.threshold) msg.innerHTML=`🎉 Has desbloqueado <strong>${t2.percent}% de descuento</strong>. Te faltan <strong>${euro(t3.threshold-subtotal)}</strong> para llegar al <strong>${t3.percent}%</strong>.`;
    else msg.innerHTML=`🏆 ¡Meta máxima! Has desbloqueado <strong>envío gratis + ${t3.percent}% de descuento</strong>.`;
  }

  const setDrawer = (drawer, open) => {
    const overlay = qs('[data-drawer-overlay]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) { overlay.hidden = !open; overlay.classList.toggle('is-visible', open); }
    document.documentElement.classList.toggle('drawer-open', open);
  };

  async function getCart(){ const r = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}}); return r.json(); }
  async function addToCart(form){
    const r = await fetch(`${root}cart/add.js`, {
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest', Accept:'application/json'},
      credentials:'same-origin',
      body:new FormData(form)
    });
    let data = {};
    try { data = await r.json(); } catch(e) {}
    if (!r.ok) {
      const message = data?.description || data?.message || 'No se pudo añadir al carrito';
      throw new Error(message);
    }
    return data;
  }
  async function changeCart(key, quantity){
    const r = await fetch(`${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:key, quantity})});
    if (!r.ok) throw new Error('No se pudo actualizar el carrito');
    return r.json();
  }
  const serviceLine = (cart, variantId, serviceKey) => cart.items.find(item => {
    const props = item.properties || {};
    const legacyGiftBox = serviceKey === 'gift_box' && props._rous_gift_service === '1';
    return Number(item.variant_id || item.id) === Number(variantId) && (props._rous_service_key === serviceKey || legacyGiftBox);
  });
  function renderServices(cart){
    qsa('[data-rous-service]').forEach(service => {
      const variantId = Number(service.dataset.serviceVariantId || 0);
      const serviceKey = service.dataset.serviceKey || '';
      const button = qs('[data-rous-service-toggle]', service);
      const label = qs('[data-rous-service-label]', service);
      if(!variantId || !serviceKey || !button) return;
      const active = Boolean(serviceLine(cart, variantId, serviceKey));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const available = service.dataset.serviceAvailable !== 'false';
      if(label) label.textContent = active ? 'Activado ✓' : (available ? 'Activar' : 'No disponible');
      button.disabled = !available;
    });
  }
  async function addService(variantId, serviceKey){
    const r = await fetch(`${root}cart/add.js`, {
      method:'POST',
      headers:{'Content-Type':'application/json', Accept:'application/json'},
      credentials:'same-origin',
      body:JSON.stringify({items:[{id:Number(variantId),quantity:1,properties:{_rous_service_key:serviceKey}}]})
    });
    let data={};
    try{data=await r.json();}catch(e){}
    if(!r.ok) throw new Error(data?.description || data?.message || 'No se pudo añadir el servicio.');
    return data;
  }
  function renderCart(cart){
    const body=qs('[data-cart-body]'), count=qs('[data-cart-count]'), total=qs('[data-cart-total]');
    if(count) count.textContent=cart.item_count;
    if(total) total.textContent=money(cart.total_price);
    renderRewards(cart);
    renderSavings(cart);
    renderDeliveryEstimate();
    renderServices(cart);
    const hasRegularItems=cart.items.some(item=>{const props=item.properties||{};return !props._rous_service_key && props._rous_gift_service!=='1'});
    qsa('[data-drawer-service-zone]').forEach(zone=>zone.hidden=!hasRegularItems);
    if(!body) return;
    if(!cart.items.length){body.innerHTML='<div class="empty-cart"><span>♡</span><p>Tu carrito está vacío.</p></div>';return;}
    body.innerHTML=cart.items.map(item=>`<div class="drawer-line" data-cart-line><a href="${item.url}" class="drawer-line-image">${item.image?`<img src="${item.image}" alt="">`:''}</a><div class="drawer-line-info"><a href="${item.url}"><b>${item.product_title}</b></a><small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</small><div class="drawer-line-bottom"><div class="drawer-qty"><button data-line-minus data-key="${item.key}" data-qty="${item.quantity}">−</button><span>${item.quantity}</span><button data-line-plus data-key="${item.key}" data-qty="${item.quantity}">+</button></div><strong>${money(item.final_line_price)}</strong></div><button class="remove-line" data-line-remove data-key="${item.key}">Eliminar</button></div></div>`).join('');
  }
  async function refreshCart(open=false){let cart=await getCart();try{cart=await syncTierDiscount(cart);}catch(e){console.warn('Rous tier discount sync failed:',e);}renderCart(cart);if(open)setDrawer(qs('[data-cart-drawer]'),true);return cart;}

  function initSwatchColors(){qsa('[data-swatch-name]').forEach(el=>{const n=(el.dataset.swatchName||'').toLowerCase();let c='#ddd';if(n.includes('oro')||n.includes('gold')||n.includes('dorado'))c='#d5ab57';else if(n.includes('plata')||n.includes('silver')||n.includes('plateado'))c='#d9d9dc';else if(n.includes('negro')||n.includes('black'))c='#222';else if(n.includes('rosa')||n.includes('rose'))c='#e8b5b8';el.style.setProperty('--swatch-color',c)});}

  function initProduct(){
    const section=qs('[data-product-section]'); if(!section)return;
    const form=qs('[data-product-form]',section); const json=qs('[data-product-json]',section); if(!form||!json)return;
    const variants=JSON.parse(json.textContent);
    const variantInput=qs('[data-variant-id]',form);
    function updateVariant(){
      const values=qsa('.product-option',form).map(fs=>qs('input[type=radio]:checked',fs)?.value);
      qsa('.product-option',form).forEach(fs=>{const s=qs('[data-selected-option]',fs),i=qs('input[type=radio]:checked',fs);if(s&&i)s.textContent=i.value});
      const v=variants.find(v=>v.options.every((o,i)=>o===values[i])); if(!v)return;
      variantInput.value=v.id;
      qsa('[data-product-price], [data-sticky-price]').forEach(el=>el.textContent=money(v.price));
      qsa('.product-actions button, .sticky-actions button').forEach(b=>b.disabled=!v.available);
      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
    }
    form.addEventListener('change',e=>{if(e.target.matches('input[type=radio]'))updateVariant()});
    qs('[data-product-buy-now]',form)?.addEventListener('click',async e=>{e.preventDefault();await addToCart(form);let cart=await getCart();try{await syncTierDiscount(cart);}catch(err){console.warn('Rous tier discount sync failed:',err);}location.href='/checkout'});
    qs('[data-sticky-buy-now]')?.addEventListener('click',async()=>{await addToCart(form);let cart=await getCart();try{await syncTierDiscount(cart);}catch(err){console.warn('Rous tier discount sync failed:',err);}location.href='/checkout'});
  }

  document.addEventListener('click', async e=>{
    const minus=e.target.closest('[data-qty-minus]'), plus=e.target.closest('[data-qty-plus]');
    if(minus||plus){const i=(minus||plus).parentElement.querySelector('input');i.value=minus?Math.max(1,(+i.value||1)-1):(+i.value||1)+1;return;}
    if(e.target.closest('[data-mobile-menu-open]')){setDrawer(qs('[data-mobile-drawer]'),true);return;}
    if(e.target.closest('[data-mobile-menu-close]')){setDrawer(qs('[data-mobile-drawer]'),false);return;}
    if(e.target.closest('[data-cart-open]')){await refreshCart(true);return;}
    if(e.target.closest('[data-cart-close]')){setDrawer(qs('[data-cart-drawer]'),false);return;}
    if(e.target.closest('[data-drawer-overlay]')){setDrawer(qs('.mobile-drawer.is-open, .cart-drawer.is-open'),false);return;}
    const serviceToggle=e.target.closest('[data-rous-service-toggle]');
    if(serviceToggle){
      const service=serviceToggle.closest('[data-rous-service]');
      const variantId=Number(service?.dataset.serviceVariantId||0);
      const serviceKey=service?.dataset.serviceKey||'';
      const label=service ? qs('[data-rous-service-label]',service) : null;
      const feedback=service ? qs('[data-rous-service-feedback]',service) : null;
      if(!service||!variantId||!serviceKey)return;
      const setServiceFeedback=(message,isError=false)=>{if(!feedback)return;feedback.textContent=message||'';feedback.classList.toggle('is-error',isError)};
      serviceToggle.disabled=true;
      setServiceFeedback('');
      try{
        let cart=await getCart();
        const line=serviceLine(cart,variantId,serviceKey);
        if(label)label.textContent=line?'Quitando…':'Añadiendo…';
        if(line) cart=await changeCart(line.key,0);
        else {await addService(variantId,serviceKey);cart=await getCart();}
        try{cart=await syncTierDiscount(cart);}catch(e){console.warn('Rous tier discount sync failed:',e);}
        renderCart(cart);
        renderServices(cart);
        setServiceFeedback(line?'Servicio eliminado.':'Servicio añadido al pedido.');
        if(service.closest('[data-full-cart-section]')) window.setTimeout(()=>window.location.reload(),300);
      }catch(err){
        setServiceFeedback(err?.message||'No se pudo actualizar el servicio.',true);
        try{renderServices(await getCart())}catch(e){}
      }finally{
        serviceToggle.disabled = service.dataset.serviceAvailable === 'false';
      }
      return;
    }
    const checkoutLink=e.target.closest('[data-cart-checkout]');
    if(checkoutLink){
      e.preventDefault();
      checkoutLink.setAttribute('aria-busy','true');
      try{let cart=await getCart();cart=await syncTierDiscount(cart);renderCart(cart);location.href=`${root}checkout`;}
      catch(err){checkoutLink.removeAttribute('aria-busy');showCartError(err?.message||'No se pudo preparar el descuento.');}
      return;
    }
    const thumb=e.target.closest('[data-gallery-thumb]');
    const galleryPrev=e.target.closest('[data-gallery-prev]');
    const galleryNext=e.target.closest('[data-gallery-next]');
    if(thumb||galleryPrev||galleryNext){
      const gallery=(thumb||galleryPrev||galleryNext).closest('[data-gallery]');
      if(!gallery)return;
      if(thumb)activateGalleryThumb(gallery,thumb);
      else stepGallery(gallery,galleryNext?1:-1);
      return;
    }
    const lineMinus=e.target.closest('[data-line-minus]'), linePlus=e.target.closest('[data-line-plus]'), remove=e.target.closest('[data-line-remove]');
    if(lineMinus||linePlus||remove){const el=lineMinus||linePlus||remove;const q=remove?0:(+el.dataset.qty||1)+(lineMinus?-1:1);let cart=await changeCart(el.dataset.key,Math.max(0,q));try{cart=await syncTierDiscount(cart);}catch(err){console.warn('Rous tier discount sync failed:',err);}renderCart(cart);return;}
  });

  function showCartError(message){
    let box=qs('[data-cart-error]');
    if(!box){
      box=document.createElement('div');
      box.setAttribute('data-cart-error','');
      box.className='cart-error-toast';
      document.body.appendChild(box);
    }
    box.textContent=message || 'No se pudo añadir el producto.';
    box.classList.add('is-visible');
    clearTimeout(box._timer);
    box._timer=setTimeout(()=>box.classList.remove('is-visible'),3500);
  }

  async function handleAddForm(f, button){
    const floating=f.matches('[data-quick-add-float]');
    const old=button.innerHTML;
    button.disabled=true;
    if(floating){
      button.innerHTML='<span class="card-quick-add-plus" aria-hidden="true">…</span><span class="card-quick-add-label">Añadiendo</span>';
    }else{
      button.textContent='Añadiendo…';
    }
    try{
      await addToCart(f);
      if(floating){
        button.classList.add('is-added');
        button.innerHTML='<span class="card-quick-add-plus" aria-hidden="true">✓</span><span class="card-quick-add-label">Añadido</span>';
      }else{
        button.textContent='Añadido ✓';
      }
      try{ await refreshCart(true); }catch(drawerError){
        console.warn('Rous cart drawer refresh failed:', drawerError);
      }
    }catch(err){
      if(floating){
        button.innerHTML='<span class="card-quick-add-plus" aria-hidden="true">!</span><span class="card-quick-add-label">Reintentar</span>';
      }else{
        button.textContent='No añadido';
      }
      showCartError(err?.message || 'No se pudo añadir el producto.');
    }finally{
      setTimeout(()=>{button.innerHTML=old;button.classList.remove('is-added');button.disabled=false},1400);
    }
  }

  function resetRousInnerZoom(area){
    if(!area)return;
    area.classList.remove('rous-inner-zoom-active');
    qsa('.gallery-main-image',area).forEach(img=>{
      img.style.transform='';
      img.style.transformOrigin='50% 50%';
    });
  }
  function moveRousInnerZoom(event,area){
    const gallery=area.closest('[data-gallery]');
    if(!gallery||gallery.dataset.galleryZoomEnabled!=='true')return;
    const main=qs('[data-gallery-slide]:not([hidden]) .gallery-main-image',area);
    if(!main)return;
    const rect=main.getBoundingClientRect();
    if(!rect.width||!rect.height)return;
    const x=event.clientX-rect.left;
    const y=event.clientY-rect.top;
    if(x<0||y<0||x>rect.width||y>rect.height){resetRousInnerZoom(area);return;}
    const xPct=Math.max(0,Math.min(100,(x/rect.width)*100));
    const yPct=Math.max(0,Math.min(100,(y/rect.height)*100));
    const scale=Math.max(1.5,Number(gallery.dataset.galleryZoomScale)||1.8);
    main.style.transformOrigin=`${xPct}% ${yPct}%`;
    main.style.transform=`scale(${scale})`;
    area.classList.add('rous-inner-zoom-active');
  }
  function initRousMagnifiers(scope=document){
    qsa('[data-gallery-zoom-area]',scope).forEach(area=>{
      if(area.dataset.rousInnerZoomReady==='true')return;
      area.dataset.rousInnerZoomReady='true';
      area.addEventListener('mousemove',event=>moveRousInnerZoom(event,area));
      area.addEventListener('mouseleave',()=>resetRousInnerZoom(area));
      area.addEventListener('mousedown',()=>resetRousInnerZoom(area));
    });
  }


  document.addEventListener('submit',async e=>{
    const f=e.target;
    if(f.matches('[data-quick-add]')){
      e.preventDefault();
      const b=qs('button[type=submit]',f);
      if(b) await handleAddForm(f,b);
      return;
    }
    if(f.matches('[data-buy-now]')){
      e.preventDefault();
      const b=qs('button[type=submit]',f);
      if(b) b.disabled=true;
      try{await addToCart(f);let cart=await getCart();try{await syncTierDiscount(cart);}catch(err){console.warn('Rous tier discount sync failed:',err);}location.href=`${root}checkout`}
      catch(err){if(b)b.disabled=false;showCartError(err?.message || 'No se pudo iniciar la compra.');}
      return;
    }
    if(f.id==='RousCartForm' && e.submitter?.name==='checkout'){
      e.preventDefault();
      const b=e.submitter;b.disabled=true;b.textContent='Aplicando descuento…';
      try{
        const fd=new FormData();
        qsa('input[name="updates[]"]',f).forEach(input=>fd.append('updates[]',input.value));
        const r=await fetch(`${root}cart/update.js`,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin',body:fd});
        let cart=await r.json();
        if(!r.ok)throw new Error(cart?.description||cart?.message||'No se pudo actualizar el carrito.');
        cart=await syncTierDiscount(cart);
        renderCart(cart);
        location.href=`${root}checkout`;
      }catch(err){b.disabled=false;b.textContent='PAGO';showCartError(err?.message||'No se pudo preparar el pago.');}
      return;
    }
    if(f.matches('[data-product-form]')){
      e.preventDefault();
      const b=qs('.add-main',f);
      if(b) await handleAddForm(f,b);
    }
  });

  document.addEventListener('DOMContentLoaded',()=>{initSwatchColors();initProduct();qsa('[data-gallery]').forEach(g=>{const thumbs=galleryThumbs(g);if(thumbs.length)syncGalleryState(g,Math.max(0,thumbs.findIndex(x=>x.classList.contains('is-active'))));});initRousMagnifiers();renderDeliveryEstimate();renderProductDeliveryTimeline();refreshCart(false).catch(()=>{});});
  document.addEventListener('shopify:section:load',e=>initRousMagnifiers(e.target));
  return {refreshCart};
})();
